import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';

import * as styles from './RecommendedNewbuildings.css';
import { Layout } from '../Layout';

interface IRecommendedNewbuildingsProps {
  compilations?: React.ReactNode;
  headerAside?: React.ReactNode;
  recommendations: React.ReactNode;
}

export const RecommendedNewbuildings: React.FC<IRecommendedNewbuildingsProps> = ({
  compilations,
  headerAside,
  recommendations,
}) => {
  return (
    <div>
      <Layout>
        <div className={styles['header']}>
          <ArticleHeading1 as="h2">Похожие ЖК</ArticleHeading1>
          {headerAside && <div className={styles['header-aside']}>{headerAside}</div>}
        </div>

        {recommendations}

        {compilations && <div className={styles['compilations']}>{compilations}</div>}
      </Layout>
    </div>
  );
};
